(function () {
  const mobileMq = window.matchMedia('(max-width: 749px)');

  function syncTpSliderSteps(root) {
    const scope = root && root.classList?.contains('section-testimonials-product') ? root : document;
    const sections = root && root.classList?.contains('section-testimonials-product')
      ? [root]
      : Array.from(scope.querySelectorAll('.section-testimonials-product'));
    for (let i = 0; i < sections.length; i++) {
      const slider = sections[i].querySelector('slider-component.slider-mobile-gutter[data-tp-desktop-step]');
      if (!slider) continue;
      const desktop = slider.getAttribute('data-tp-desktop-step') || '3';
      const step = mobileMq.matches ? '1' : String(desktop);
      slider.querySelectorAll('.featured-collection__slider-buttons button[name="previous"], .featured-collection__slider-buttons button[name="next"]').forEach(function (btn) {
        btn.dataset.step = step;
      });
    }
  }

  let mqListenerBound = false;
  function bindMqListener() {
    if (mqListenerBound) return;
    mqListenerBound = true;
    const handler = function () {
      syncTpSliderSteps(document);
    };
    if (mobileMq.addEventListener) {
      mobileMq.addEventListener('change', handler);
    } else {
      mobileMq.addListener(handler);
    }
  }

  function syncArrowTop(gutter) {
    if (!gutter.querySelector('.featured-collection__slider-buttons')) return;
    const card = gutter.querySelector('.testimonial-product-card__inner');
    if (!card) return;
    const g = gutter.getBoundingClientRect();
    const c = card.getBoundingClientRect();
    const centerPx = c.top + c.height * 0.5 - g.top;
    const next = `${Math.round(centerPx)}px`;
    if (gutter.style.getPropertyValue('--fc-arrow-top').trim() !== next) {
      gutter.style.setProperty('--fc-arrow-top', next);
    }
  }

  function bind(gutter) {
    if (gutter.dataset.tpArrowAlignBound) return;
    gutter.dataset.tpArrowAlignBound = 'true';
    const run = function () {
      syncArrowTop(gutter);
    };
    run();
    const ro = new ResizeObserver(run);
    ro.observe(gutter);
    const slide = gutter.querySelector('.testimonial-product-card__inner');
    if (slide) ro.observe(slide);
  }

  function initWithin(container) {
    syncTpSliderSteps(container);
    bindMqListener();

    const sections = container.classList?.contains('section-testimonials-product')
      ? [container]
      : Array.from(container.querySelectorAll('.section-testimonials-product'));
    for (let i = 0; i < sections.length; i++) {
      const gutter = sections[i].querySelector('.slider-mobile-gutter');
      if (gutter) bind(gutter);
    }
  }

  function onReady() {
    initWithin(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', onReady, { once: true });
  } else {
    onReady();
  }

  document.addEventListener('shopify:section:load', function (event) {
    if (event.target.classList?.contains('section-testimonials-product')) {
      initWithin(event.target);
    }
  });
})();
